import { Box, Card, CardContent, Stack, Typography, useMediaQuery } from '@mui/material';

const DashboardCard = ({
  title,
  subtitle,
  children,
  action,
  footer,
  cardheading,
  headtitle,
  headsubtitle,
  middlecontent,
}) => {
  const lgDown = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  return lgDown ? (
    <Card
      sx={{
        padding: 0,
        height: { lg: '100px', md: '100px', sm: '85px', xs: '85px' },
        maxWidth: '45vw',
        minWidth: '45vw',
      }}
      variant="outlined"
    >
      <CardContent sx={{ p: '10px 0px 0px 5px', height: { lg: '100px', md: '100px', xs: '85px' } }}>
        <Stack
          direction="row"
          spacing={2}
          justifyContent="space-between"
          alignItems={'center'}
          sx={{ marginBottom: { xs: '1rem', lg: '1.5rem' } }}
        >
          <Box>
            <Typography variant="h5" style={{ margin: 0, padding: 0 }}>
              {title}
            </Typography>

            {subtitle ? (
              <Typography variant="subtitle2" color="textSecondary">
                {subtitle}
              </Typography>
            ) : (
              ''
            )}
          </Box>
        </Stack>

        {children}
      </CardContent>
      {middlecontent}
      {footer}
    </Card>
  ) : (
    <Card sx={{ padding: 0, height: '200px', maxWidth: '90vw' }} variant={'outlined'}>
      {cardheading ? (
        <CardContent>
          <Typography variant="h5">{headtitle}</Typography>
          <Typography variant="subtitle2" color="textSecondary">
            {headsubtitle}
          </Typography>
        </CardContent>
      ) : (
        <CardContent sx={{ p: '30px 0px 30px 30px', height: '120px' }}>
          <Stack
            direction="row"
            spacing={2}
            justifyContent="space-between"
            alignItems={'center'}
            sx={{ marginBottom: { xs: '1rem', sm: '2rem', md: '1.8rem', lg: '1.5rem' } }}
          >
            <Box>
              <Typography variant="h5">{title}</Typography>

              {subtitle ? (
                <Typography variant="subtitle2" color="textSecondary">
                  {subtitle}
                </Typography>
              ) : (
                ''
              )}
            </Box>
            {action}
          </Stack>

          {children}
        </CardContent>
      )}

      {middlecontent}
      {footer}
    </Card>
  );
};

export default DashboardCard;
